import httpClient from '@/http-client'

export const store = file => {
  return httpClient
    .post('/api/companies/photos', file)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const get = id => {
  return httpClient
    .get(`/api/companies/${id}/photos`, {
      responseType: 'arraybuffer'
    })
    .then(response =>
      Promise.resolve(`data:image/jpg;base64,${new Buffer(response.data, 'binary').toString('base64')}`)
    )
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store }
